/**
 * @file Homepage Intro
 */

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * Homepage Intro component
 */
const vHpIntro = () => {
	const hpIntro = document.querySelector('.v-hp-intro');

	if (!hpIntro) {
		return;
	}

	const { hash } = window.location;

	if (!hash || hash !== `#${hpIntro.getAttribute('id')}`) {
		return;
	}

	const query        = window.matchMedia('(min-width: 768px)');
	const headerHeight = document.querySelector('.v-header').getBoundingClientRect().height;

	gsap.registerPlugin(ScrollToPlugin);

	gsap.to(window, {
		duration: 0.75,
		delay:    0.5,
		scrollTo: {
			y: hpIntro.offsetTop + (query.matches ? 1.25 : 2) * headerHeight,
		},
	});
};

export default vHpIntro;
